import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const ArrowDownIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M5.31993 10.02L8.52993 13.23L10.4899 15.2C11.3199 16.03 12.6699 16.03 13.4999 15.2L18.6799 10.02C19.3599 9.34001 18.8699 8.18001 17.9199 8.18001H12.3099H6.07993C5.11993 8.18001 4.63993 9.34001 5.31993 10.02Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default ArrowDownIcon;
